export default {
    backEndList: {
        method: "POST",
        url: "/sortingCityAdmin/gov/broke-order-list",
        name: "分拣中心订单列表"
    },
    frontEndList: {
        method: "POST",
        url: "/sortingCityAdmin/gov/waste-order-list",
        name: "居民订单列表"
    },
    overviewList: {
        method: "POST",
        url: "/sortingCityAdmin/gov/overview",
        name: "分拣中心数据概览"
    },
    frontOverviewList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/overview",
        name: "居民数据概览"
    },
    parentCategory: {
        method: "GET",
        url: "/v2/order/category/broke/admin-parent-category",
        name: "大类"
    },
    categoryNewList: {
        method: "POST",
        url: "/common/category/new-list",
        name: "类目列表"
    },
    toxicList: {
        method: "POST",
        url: "/sortingCityAdmin/gov/toxic-list",
        name: "有毒有害回收列表"
    },
    sortingList: {
        method: "POST",
        url: "/sortingCityAdmin/back-end/sorting",
        name: "分拣中心列表"
    },
    frontStartTask: {
        method: "POST",
        url: "/sortingCityAdmin/gov/start-task-waste",
        name: "居民导出"
    },
    backStartTask: {
        method: "POST",
        url: "/sortingCityAdmin/gov/start-task",
        name: "分拣中心导出"
    },
};